export default __webpack_public_path__ + "static/react-ad7e5df9509873eb4f00a635eea63914.svg";